// extracted by mini-css-extract-plugin
export default {"-large":"BVl1KAabXvk2NHYzaSLD","footer":"dNVlVXpfcgnzlt0pXEvN","signupFormName":"ke_OJMmmxNI1Hs7KyiYU"};